import React from "react";

import { Button, Grid, Typography } from "@mui/material";
import { useForm, ValidationError } from "@formspree/react";

import { StyledTextField, ThankYouBox } from "../styles";

const ContactForm = () => {
  const formID = "xoqovezw";
  const [state, handleSubmit] = useForm(formID);

  if (state.succeeded) {
    return (
      <ThankYouBox>
        <Typography color="white" variant="h4" p={3}>
          Thank you for contacting us! We will get back to you soon.
        </Typography>
      </ThankYouBox>
    );
  }
  return (
    <Grid
      container
      spacing={3}
      component="form"
      sx={{ padding: 3 }}
      onSubmit={handleSubmit}
    >
      <Grid item xs={12} sm={6}>
        <StyledTextField
          label="First Name"
          variant="standard"
          color="primary"
          name="First Name"
          id="First Name"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <StyledTextField
          label="Last Name"
          variant="standard"
          color="primary"
          name="Last Name"
          id="Last Name"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <StyledTextField
          label="Email"
          variant="standard"
          color="primary"
          type="email"
          name="email"
          id="email"
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <StyledTextField
          label="Company Name"
          variant="standard"
          color="primary"
          name="Company Name"
          id="Company Name"
        />
      </Grid>
      <Grid item xs={12}>
        <StyledTextField
          label="Message"
          variant="standard"
          color="primary"
          name="message"
          id="message"
          multiline
          rows={2}
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ float: "right", marginTop: 3 }}
          disabled={state.submitting}
          type="submit"
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default ContactForm;
